var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2251 24.8724L33.2586 25.8955L34.0449 25.2402L36.6183 23.0957C37.2084 22.6039 38.0854 22.6837 38.5772 23.2738C38.7855 23.5238 38.8996 23.8389 38.8996 24.1642V33.3634C38.8996 34.1316 38.2769 34.7543 37.5087 34.7543C37.1833 34.7543 36.8682 34.6403 36.6183 34.432L34.0449 32.2875L33.2586 31.6322L33.2251 32.6553C33.1674 34.4168 31.7209 35.8275 29.9451 35.8275H22.3814C20.5689 35.8275 19.0996 34.3581 19.0996 32.5457V24.982C19.0996 23.1695 20.5689 21.7002 22.3814 21.7002H29.9451C31.7209 21.7002 33.1674 23.1108 33.2251 24.8724ZM33.4068 26.9316L33.2269 27.0816V27.3158V30.2119V30.4461L33.4068 30.596L37.1886 33.7475L38.0087 34.431V33.3634V24.1642V23.0967L37.1886 23.7801L33.4068 26.9316ZM22.3814 22.5911C21.061 22.5911 19.9905 23.6616 19.9905 24.982V32.5457C19.9905 33.8661 21.061 34.9366 22.3814 34.9366H29.9451C31.2655 34.9366 32.336 33.8661 32.336 32.5457V24.982C32.336 23.6616 31.2655 22.5911 29.9451 22.5911H22.3814Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoActive);
export default __webpack_public_path__ + "static/media/videoActive.d04c5da6d7c4d9ac7324a9fe422bc59d.svg";
export { ForwardRef as ReactComponent };